import type { FC, SVGProps } from 'react';

export const GoogleShoppingLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 271.12 305.88"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#4285f4"
      d="M184.22,57.35c-4.07,0-7.71-2.89-8.52-7.04-3.82-19.7-19.94-32.94-40.11-32.94s-36.34,13.24-40.16,32.94c-.91,4.71-5.48,7.8-10.18,6.88-4.71-.91-7.79-5.47-6.88-10.18C83.73,19.33,107.25,0,135.54,0s51.85,19.33,57.22,47.01c.92,4.71-2.17,9.27-6.88,10.18-.56.11-1.12.16-1.67.16Z"
    />
    <path
      fill="#fabb05"
      d="M270.23,115.09l.65-5.09c1.09-8.48-1.52-17.02-7.15-23.43-5.64-6.42-13.74-10.1-22.27-10.1H56.22c-.46,21.03,7.31,42.22,23.32,58.28,31.09,31.17,81.46,31.21,112.52.07,21.39-20.85,50.09-28.62,78.17-19.72Z"
    />
    <path
      fill="#4285f4"
      d="M29.65,76.47c-8.52,0-16.63,3.68-22.26,10.1C1.76,92.98-.84,101.52.24,110l20.6,160.82c21.2.68,42.6-7.02,58.77-23.23,31.05-31.13,31.02-81.66-.07-112.84-16.01-16.06-23.78-37.25-23.32-58.28h-26.57Z"
    />
    <path
      fill="#34a853"
      d="M270.25,114.94c-26.23-8.14-55.43-2.95-78.19,19.87-31.05,31.14-31.02,81.66.07,112.84,16,16.04,23.77,37.22,23.31,58.23h4.26c14.92,0,27.51-11.11,29.41-25.95l21.13-164.99Z"
    />
    <path
      fill="#e94235"
      d="M79.61,247.58c-16.17,16.21-37.57,23.91-58.77,23.23l1.17,9.11c1.9,14.84,14.5,25.95,29.41,25.95h164.01c.45-21.01-7.3-42.18-23.31-58.23-31.1-31.18-81.47-31.21-112.52-.07Z"
    />
  </svg>
);
